import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Box, Grid2, Stack, Toolbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import LogoIcon from "../assets/images/logo_icon.png";
import { sessionRepository } from "../services/sessionRepository";
import { AlertType } from "../shared/constants/enums";
import { Heading, WarningDialog } from "../shared/ReusableComponents";
import { logout } from "../store/loginSlice";
import { toast } from "../store/toastSlice";
import "./header.module.css";
import styles from "./header.module.css";
import { useMsal } from "@azure/msal-react";
import { BrowserUtils } from "@azure/msal-browser";
import { useState } from "react";
import { msalStaffConfig } from "./login/auth/authConfig";
import { persistor } from "../store/store";

const Header = ({
  name,
  avatar,
  role,
  leftNavExpandMenu,
  setLeftNavExpandMenu,
}: {
  name: string;
  avatar: string;
  role: string;
  leftNavExpandMenu: boolean;
  setLeftNavExpandMenu: (toggle: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state: any) => state.login);
  const [dialogOpen, setDialogOpen] = useState(false);

  const { inProgress, instance } = useMsal();

  const handleMenuToggle = () => {
    setLeftNavExpandMenu(!leftNavExpandMenu);
  };

  const handleConfirm = () => {
    setDialogOpen(false); // Close the dialog
    sessionRepository.Logout().then(() => {
      persistor.purge(); // Clear the persisted state
      instance
        .logoutRedirect({
          account: instance.getActiveAccount(),
          postLogoutRedirectUri: msalStaffConfig.auth.postLogoutRedirectUri,
        })
        .catch((error) => {
          console.log("Logout error:", error);
        });
    });
  };

  const logoutHandler = () => {
    setDialogOpen(true); // Open the dialog
  };

  return (
    <>
      <Grid2
        size={{ sm: 12, md: 6, lg: 6, xl: 6 }}
        position="static"
        sx={{
          paddingTop: 1,
          paddingBottom: 1,
          borderBottom: "2px solid rgb(241, 233, 233)",
        }}
      >
        <Toolbar disableGutters>
          <Grid2
            size={{ sm: 12, md: 12 }}
            sx={{ paddingLeft: 4 }}
            display={"flex"}
            alignItems={"center"}
          >
            <Link to="#">
              {!leftNavExpandMenu && (
                <img src={Logo} alt="logo" className={styles.logoImage} />
              )}
              {leftNavExpandMenu && (
                <img
                  src={LogoIcon}
                  alt="LogoIcon"
                  className={styles.logoImageIcon}
                />
              )}
            </Link>

            <Stack>
              <MenuOpenIcon
                data-testid="menu-open-icon"
                className={`${styles.navIcon} ${styles.openIcon}`}
                onClick={() => handleMenuToggle()} // Toggle menu on icon click
                style={{ display: leftNavExpandMenu ? "none" : "block" }} // Hide MenuOpenIcon when the menu is open
              />

              <MenuIcon
                className={`${styles.navIcon} ${styles.closeIcon}`}
                onClick={() => handleMenuToggle()} // Toggle menu on icon click
                style={{ display: leftNavExpandMenu ? "block" : "none" }} // Hide MenuIcon when the menu is closed
              />
            </Stack>
          </Grid2>

          <Box
            display="flex"
            alignItems="center"
            justifyContent={"flex-end"}
            paddingRight="20px"
            flexGrow={1}
          >
            <Box marginLeft={1} marginRight={0.5} sx={{ paddingRight: 1 }}>
              <Grid2
                sx={{ display: "flex" }}
                alignItems={"right"}
                paddingRight={0}
              >
                <Heading type="body1" text={name} isBold={true} />
              </Grid2>
              <Heading type="subtitle1" text={role} />
            </Box>
            <span
              className={`${styles.logout} material-symbols-outlined logout`}
              onClick={logoutHandler}
            >
              logout
            </span>
          </Box>
        </Toolbar>
      </Grid2>
      <WarningDialog
        text="You chose to log out, don't forget to save your work before logging out."
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        handleConfirm={handleConfirm}
      />
    </>
  );
};

export default Header;
